import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M19.833 21.502h-4.666l-5.192 3.453a1.163 1.163 0 0 1-1.808-.968v-2.485c-3.5 0-5.834-2.334-5.834-5.834v-7c0-3.5 2.334-5.833 5.834-5.833h11.666c3.5 0 5.834 2.333 5.834 5.833v7c0 3.5-2.334 5.834-5.834 5.834"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14 13.253v-.245c0-.793.49-1.213.98-1.551.478-.327.957-.747.957-1.517A1.93 1.93 0 0 0 14 8.003a1.93 1.93 0 0 0-1.937 1.937m1.932 6.102h.01"
    }, null, -1)
  ]))]))
}
export default { render: render }